// Zentrale Helfer für Miniatur-Bilder (Rezepte + Zutaten)

export function IstTouchGeraet() {
  return window.matchMedia && window.matchMedia('(pointer: coarse)').matches
}

export function BildUrl(Typ, Id, BildVersion) {
  return `/backend/bildLaden.php?Typ=${Typ}&Id=${Id}&V=${BildVersion || 0}`
}

async function BitmapLaden(Datei) {
  // createImageBitmap dreht das Bild automatisch anhand der EXIF-Ausrichtung (Handy-Fotos)
  if ('createImageBitmap' in window) {
    try {
      return await createImageBitmap(Datei, { imageOrientation: 'from-image' })
    } catch {
      // Fallback unten
    }
  }
  return new Promise((Aufloesen, Ablehnen) => {
    const Bild = new Image()
    const ObjektUrl = URL.createObjectURL(Datei)
    Bild.onload = () => { URL.revokeObjectURL(ObjektUrl); Aufloesen(Bild) }
    Bild.onerror = () => { URL.revokeObjectURL(ObjektUrl); Ablehnen(new Error('Bild konnte nicht gelesen werden.')) }
    Bild.src = ObjektUrl
  })
}

// Verkleinert eine Bilddatei clientseitig auf max. 512px Kantenlänge und liefert eine JPEG-Data-URL
export async function DateiZuVorschaubild(Datei, MaxKante = 512) {
  const Bitmap = await BitmapLaden(Datei)
  const Faktor = Math.min(1, MaxKante / Math.max(Bitmap.width, Bitmap.height))
  const Breite = Math.max(1, Math.round(Bitmap.width * Faktor))
  const Hoehe = Math.max(1, Math.round(Bitmap.height * Faktor))

  const Leinwand = document.createElement('canvas')
  Leinwand.width = Breite
  Leinwand.height = Hoehe
  const Kontext = Leinwand.getContext('2d')
  // Weißer Grund, damit transparente PNGs im JPEG nicht schwarz werden
  Kontext.fillStyle = '#ffffff'
  Kontext.fillRect(0, 0, Breite, Hoehe)
  Kontext.drawImage(Bitmap, 0, 0, Breite, Hoehe)

  return Leinwand.toDataURL('image/jpeg', 0.82)
}
